export function normalizeForSavedByCheck(value: string | null | undefined): string {
  return (value ?? "").toLowerCase().replaceAll(/\s/g, "");
}

export function containsSavedByInValue(value: string | null | undefined): boolean {
  return normalizeForSavedByCheck(value).includes("savedby");
}

export function isSavedByItem(params: {
  sku?: string | null;
  productName?: string | null;
  variantName?: string | null;
}): boolean {
  const { sku, productName, variantName } = params;
  return (
    containsSavedByInValue(sku) || containsSavedByInValue(productName) || containsSavedByInValue(variantName)
  );
}
